import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pagination } from '../../models/mat-account.model';
import { DtoSchool } from '../../models/school.model';

@Component({
  selector: 'app-independent-entity',
  templateUrl: './independent-entity.component.html'
})
export class IndependentEntityComponent {
  @Output() refreshData = new EventEmitter<Pagination>();
  @Output() actionTriggered = new EventEmitter<any>();
  @Input() schoolData: DtoSchool[] = [];
  searchTerm: string = '';
  activeTab: string = "IndividualSchool";
  pageSize:number = 10;
  pageNumber:number = 0;
  pageOffSet:number = 0;
  sortColumn: string = "";
  sortDirection: string = "";

  getGridData(sortColumn = "", sortDirection = "", pageOffSet = 0,  pageSize=0){
    if(sortColumn){
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
    let payload: any = {};
      payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
      payload.sortDirection = this.sortDirection;
      payload.pageOffset = pageOffSet;
      payload.pageSize = pageSize;
      payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";
      this.refreshData.emit(payload);
  }
}
